module.exports = __webpack_public_path__ + "img/sc-rule-tile.86d05c4d.png";